import { toMoney } from '@/modules/core/utils/formats';
import { i18n } from '../localization';
export default {
  series: [{
    data: [],
  }],
  xaxis: {
    categories: [],
  },
  yaxis: {
    labels: { show: true },
  },
  chart: {
    type: 'bar',
    foreColor: '#fff',
    toolbar: { show: false },
    locales: [{
      name: 'pt',
      options: {
        months: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
        shortMonths: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        days: [
          'Domingo',
          'Segunda',
          'Terça',
          'Quarta',
          'Quinta',
          'Sexta',
          'Sábado',
        ],
        shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        toolbar: {
          exportToSVG: 'Baixar SVG',
          exportToPNG: 'Baixar PNG',
          exportToCSV: 'Baixar CSV',
          menu: 'Menu',
          selection: 'Selecionar',
          selectionZoom: 'Selecionar Zoom',
          zoomIn: 'Aumentar',
          zoomOut: 'Diminuir',
          pan: 'Navegação',
          reset: 'Reiniciar Zoom',
        },
      },
    },
    ],
    defaultLocale: 'pt',
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      barHeight: '70%',
      distributed: true,
      horizontal: true,
      dataLabels: { position: 'bottom' },
    },
  },
  dataLabels: {
    enabled: true,
    textAnchor: 'start',
    style: { colors: ['#fff'] },
    offsetX: 0,
    dropShadow: { enabled: true },
  },
  fill: { colors: ['#e75e0f'] },
  stroke: { width: 1, colors: ['#fff'] },
  legend: { show: false },
  tooltip: {
    theme: 'dark',
    x: { show: false },
    y: {
      formatter: (value) => toMoney(value),
      title: {
        formatter: (value, opt) => opt.w.globals.labels[opt.dataPointIndex] + ': ',
      },
    },
  },
  noData: {
    text: i18n.global.t('naoForamEncontradasInfosParaOsFiltrosFornecidos'),
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
  },
};
